export default {"src":"/_next/static/media/others.5b54019c.svg","height":40,"width":40};